import { initWidget } from '@/utils/Shell';
import MemberSignupFormWidget from './MemberSignupFormWidget.vue';

initWidget('MemberSignupFormWidget', MemberSignupFormWidget);
